import React from 'react';
import { Card, CardBody, Chip, Tooltip } from '@patternfly/react-core';
import SVG from 'react-inlinesvg';

import './index.scss';
import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  iconSrc?: string;
  isHidden?: boolean;
  isInline?: boolean;
  dataAnalyticId?: string;
  variant?: 'warning' | 'info' | 'success';
  tooltipContent?: string;
};

const InfoCard = ({
  children,
  iconSrc,
  isHidden = false,
  isInline = false,
  dataAnalyticId,
  variant,
  tooltipContent,
}: Props) => {
  if (isHidden) return null;

  const cardContent = (
    <div className="info-card-body">
      {iconSrc && !isInline && <SVG src={iconSrc} height={24} width={24} />}

      {isInline ? (
        children
      ) : (
        <Chip
          className={classNames('info-card-chip', `${variant}-chip`)}
          isReadOnly
        >
          {children}
        </Chip>
      )}
    </div>
  );

  return (
    <Card className="info-card" isRounded data-analytics-id={dataAnalyticId}>
      <CardBody>
        {tooltipContent && !isInline ? (
          <Tooltip content={tooltipContent}>{cardContent}</Tooltip>
        ) : (
          cardContent
        )}
      </CardBody>
    </Card>
  );
};

export default InfoCard;
